var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"TableFilters",style:(_vm.filterStyle)},_vm._l((_vm.filtersWithComponents),function(filter,index){return _c('div',{key:`filter_${index}`,style:({'grid-area' : filter.id })},[_c(filter.componentName,{tag:"component",attrs:{"filter-config":filter}})],1)}),0),_c(_vm.TableActiveFilters,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }